/**
* Created By: Melissa López
* Creation Date: 14/09/2023
* PBI: 78286 - Vista Paso 1 Cotizador de Crédito
*
* Last Modifier:
* Last Modification: 
*
* Feat: 
*
* version: 1.0.0
* copyright: 2023 INDUSTRIAS RESSER S.A DE C.V
*/
import React, { useState, useEffect } from 'react';
import { useAppSelector } from '../hooks/storeHooks';
import { getAnalytics, logEvent } from '@firebase/analytics';
import styles from '../styles/Step.style';
import { FirstStepArrendamiento } from './FirstStepLeasing';
import { FirstStepCredit } from './FirstStepCredit';
import { DataCotizador } from '../reducer/slices/DataCotizador';

const useStyle = styles;

export const FirstStepView = () => {
    const dataCotizador = useAppSelector(state => state.DataCotizador);
    const analytics = getAnalytics();

    useEffect(() => {
        logEvent(analytics, "view_first_screen");
    }, [])
        return (
            <>
            {dataCotizador?.quoteType === 0 ? (
                <FirstStepArrendamiento/>
            ):(
                <FirstStepCredit/>
            )}
            </>
        )
 
    }
